<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('规则名称')">
              <j-input :placeholder="$t('规则名称模糊查询')" v-model="queryParam.warnName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('告警类型')">
              <a-select v-model="queryParam.warnType" :placeholder="$t('请选择告警类型')">
                <a-select-option v-for="data in warnTypeListOptions" :key="data.key" :value="data.key">
                  {{data.title}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!--
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
              -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!--
      <a-button type="primary" icon="download" @click="handleExportXls('meter_maintenance_warn_config')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <maintenance-device-warn-config-modal ref="modalForm" @ok="modalFormOk"></maintenance-device-warn-config-modal>
  </a-card>
</template>

<script>
import i18n from '@/i18n'

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {isUndefined} from '@/utils/validate'
  import maintenanceDeviceWarnConfigModal from './modules/maintenanceDeviceWarnConfigModal'
  import JInput from '@/components/jeecg/JInput'
  import { getAction } from '@/api/manage'

  const warnTypeList= [
          {key: 1,title: i18n.t('电池电压告警')},
          {key: 2,title: i18n.t('信号告警')},
          {key: 3,title: i18n.t('已开户失联告警')},
          {key: 4,title: i18n.t('复位告警')},
          {key: 5,title: i18n.t('关阀走水')},
          {key: 6,title: i18n.t('未开户失联告警')}
        ]
  const warnTypeListData = [
          {key: 1,title: i18n.t('电池电压告警')},
          //{key: 2,title: '信号告警'},
          {key: 3,title: i18n.t('已开户失联告警')},
          {key: 4,title: i18n.t('复位告警')},
          {key: 5,title: i18n.t('关阀走水')},
          {key: 6,title: i18n.t('未开户失联告警')}
        ]
  export default {
    name: 'maintenanceDeviceWarnConfigList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      maintenanceDeviceWarnConfigModal,
      JInput
    },
    data () {
      return {
        description: 'meter_maintenance_warn_config管理页面',
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnConfig/list",
          delete: "/jeecg-charge/meter/meterMaintenanceWarnConfig/delete",
          deleteBatch: "/jeecg-charge/meter/meterMaintenanceWarnConfig/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterMaintenanceWarnConfig/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterMaintenanceWarnConfig/importExcel",
          queryMeterMaintenanceWarnRecord: "/jeecg-charge/meter/meterMaintenanceWarnRecord/list"
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：告警类型下拉选项（title 随语言切换）
      warnTypeListOptions() {
        return warnTypeListData.map(item => ({ ...item, title: this.$t(item.title) }))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('告警规则名称'),
            align:"center",
            dataIndex: 'warnName'
          },
          {
            title: this.$t('是否启用'),
            align:"center",
            dataIndex: 'warnState',
            customRender: (t,r,index) => {
              let obj = {0: '未启用',1: '启用'}
              if(!isUndefined(obj[t])) {
                return this.$t(obj[t])
              }
              return this.$t('未知');
            }
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('告警类型'),
            align:"center",
            dataIndex: 'warnType',
            customRender: (t,r,index) => {
              let typeIndex = warnTypeList.findIndex((item)=>{
                return item.key == t;
              })
              if(typeIndex>-1) {
                return this.$t(warnTypeList[typeIndex].title)
              }
              return this.$t('未知');
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      initDictConfig(){
      },
      handleEdit: function (record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.voltageWarnConfig = record.id
        getAction(this.url.queryMeterMaintenanceWarnRecord, params).then((res) => {
          if(res.success&&res.result.records.length>0){
            this.$refs.modalForm.isUsed = true;
          }else{
            this.$refs.modalForm.isUsed = false;
          }
          this.$refs.modalForm.disableSubmit = false;
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title = this.$t("编辑");
        })

        
      },
    }
  }
</script>
<style scoped>
</style>